import React from 'react';
import { NSpinner, NStatusTag, NTooltip } from '@innersource-nn/novoui-react';
import AwsStatuses from './AwsStatuses';
import {
    StatusTagSizes,
    StatusTagState,
} from '@innersource-nn/novoui-react/dist/external-lib/NStatusTag/NStatusTagProps';

interface StatusWithTooltipProps {
    content: string;
    size?: StatusTagSizes;
}
interface StatusInfo {
    tag: string;
    status: StatusTagState;
    description?: string;
    progress?: boolean;
}

export interface StatusInfoType {
    [key: string]: StatusInfo;
}
const StatusWithTooltip = ({ content, size }: StatusWithTooltipProps) => {
    const { tag, status, description } = AwsStatuses[content] || {
        tag: content,
        variant: 'info',
    };

    return (
        <div className="flex items-center">
            <NTooltip content={description} placement="down" variant="light">
                <NStatusTag label={tag} size={size} state={status} />
            </NTooltip>
            {AwsStatuses[content]?.progress && (
                <div className="pl-2 pr-2 flex items-center">
                    <NSpinner color="blue" size="small" />
                </div>
            )}
        </div>
    );
};

export default StatusWithTooltip;
